/** Тонкие штриховые иконки — без внешних зависимостей. */

type Props = { size?: number };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
});

export function IconCalendar({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <rect x="3" y="5" width="18" height="16" rx="4" />
      <path d="M8 3v4M16 3v4M3 10h18" />
    </svg>
  );
}

export function IconUsers({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <circle cx="9" cy="8" r="3.4" />
      <path d="M3.5 20c0-3.2 2.5-5.4 5.5-5.4s5.5 2.2 5.5 5.4" />
      <path d="M16.5 5.6a3.4 3.4 0 0 1 0 6.5M18 14.9c2 .7 3.4 2.6 3.4 5.1" />
    </svg>
  );
}

export function IconBadge({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <path d="M12 2.7 20 6v6c0 4.6-3.3 8.2-8 9.3-4.7-1.1-8-4.7-8-9.3V6z" />
      <circle cx="12" cy="10.5" r="2.4" />
      <path d="M8.2 17c.7-1.7 2.1-2.6 3.8-2.6s3.1.9 3.8 2.6" />
    </svg>
  );
}

export function IconPulse({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <rect x="3" y="4" width="18" height="16" rx="4" />
      <path d="M6.5 13h2.2l1.6-3.6 2.4 6 1.7-3.4h3.1" />
    </svg>
  );
}

export function IconLogout({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <path d="M14 4h3.5A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5H14" />
      <path d="M10 8l-4 4 4 4M6 12h9" />
    </svg>
  );
}

export function IconSend({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <path d="M21 4 3 10.6l6.4 2.3M21 4l-6.3 16-3.3-7.1M21 4 9.4 12.9" />
    </svg>
  );
}

export function IconKey({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <circle cx="8" cy="14" r="4" />
      <path d="M11 11.5 20 3M17 6l2.2 2.2M14.5 8.5l2 2" />
    </svg>
  );
}

export function IconChevron({ size = 16 }: Props) {
  return (
    <svg {...base(size)}>
      <path d="M6 9.5 12 15l6-5.5" />
    </svg>
  );
}

/**
 * Фирменный знак — монограмма ELG. Здесь это текст, а не рисунок:
 * так он набирается тем же шрифтом, что и весь интерфейс, и остаётся
 * чётким на любом экране.
 */
export function IconLogo() {
  return <span className="logo-monogram">ELG</span>;
}

export function IconLead({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <rect x="3" y="5" width="18" height="14" rx="4" />
      <circle cx="9" cy="11" r="2.2" />
      <path d="M5.6 16.5c.6-1.5 1.9-2.3 3.4-2.3s2.8.8 3.4 2.3M15 10h4M15 13.5h2.5" />
    </svg>
  );
}

export function IconUpload({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <path d="M12 15V4M8.5 7.5 12 4l3.5 3.5" />
      <path d="M4 14v3.5A2.5 2.5 0 0 0 6.5 20h11a2.5 2.5 0 0 0 2.5-2.5V14" />
    </svg>
  );
}

/** Воронка: колонки карточек */
export function IconBoard({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <rect x="3.5" y="4" width="5" height="16" rx="1.8" />
      <rect x="9.5" y="4" width="5" height="11" rx="1.8" />
      <rect x="15.5" y="4" width="5" height="7" rx="1.8" />
    </svg>
  );
}

/** Отчёт: горизонтальные полосы */
export function IconChart({ size = 19 }: Props) {
  return (
    <svg {...base(size)}>
      <path d="M4 4v16h16" />
      <path d="M8 9h9" />
      <path d="M8 13h6" />
      <path d="M8 17h11" />
    </svg>
  );
}
